import Web3 from "web3";
const ERC20_ABI = [
  {
    constant: false,
    inputs: [
      { name: "spender", type: "address" },
      { name: "amount", type: "uint256" },
    ],
    name: "approve",
    outputs: [{ name: "", type: "bool" }],
    type: "function",
  },
];

const Approve = async (
  Token_adress: any,
  Contract_adress: any,
  amount: number
) => {
  try {
    const web3Instance = new Web3(window.ethereum);
    const contractInstance = new web3Instance.eth.Contract(
      ERC20_ABI,
      Token_adress
    );
    const accounts = await web3Instance.eth.requestAccounts();
    const userAddress = accounts[0];
    await contractInstance.methods
      .approve(Contract_adress, amount)
      .send({ from: userAddress });
    return true;
  } catch (err) {
    return false;
  }
};
export default Approve;
